import React from "react";
import "./ProjectDetailsHero.css";

const ProjectDetailsHero = ({title}) => {
  return (
    <div className="project-details-hero-wrapper">
      <div className="hero-spotlight"></div>
      <svg aria-hidden="true" className="svg-grid">
        <defs>
          <pattern
            id="hero"
            width="80"
            height="80"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none"></path>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#hero)"
          className="my-rect"
        ></rect>
      </svg>
      <div className="container">
        <div className="project-details-large-title">
          <div className="large-title">
            <h1>{title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsHero;
